export const BasePath = '';

export const PermissionClientAdminRead = 'clientadmin:read';
export const PermissionClientAdminWrite = 'clientadmin:write';
